<template>
  <div class="Home">
    <!-- 版心 -->
    <div class="_center WidCon">
      <!-- 切换显示内容 -->
      <div class="conent">
        <div class="conent_box">
          <h3>平台优势</h3>
          <i class="selected"></i>
          <div class="_text">打破专业建设壁垒，培养复合型应用人才</div>
          <ul class="personnel">
            <li>
              <div class="personnel1">
                <img src="@/zh-website/src/assets/platform1.png" alt />
              </div>
              <div class="personnel2">
                <h3>课程体系接轨行业</h3>
                <p>
                  结合企业产业需求，规划系统的课程体系，<br />全面培养学生结构化能力，跨专业融合共享。
                </p>
              </div>
            </li>
            <li>
              <div class="personnel1">
                <img src="@/zh-website/src/assets/platform2.png" alt />
              </div>
              <div class="personnel2">
                <h3>丰富原厂案例课程</h3>
                <p>
                  面对主流行业场景，将综合案例进行二次转化，<br />适配教学实训的训战场景。
                </p>
              </div>
            </li>
            <li>
              <div class="personnel1">
                <img src="@/zh-website/src/assets/platform3.png" alt />
              </div>
              <div class="personnel2">
                <h3>融入华为原厂技术</h3>
                <p>
                  基于华为原厂核心技术研发实训平台，<br />实训项目全，资金投入低，充分释放设备性能。
                </p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 平台资源 -->
        <div class="conent_box resources">
          <h3>平台资源</h3>
          <i class="selected"></i>
          <!-- 课程 -->
          <div class="course">
            <div class="course_box">
              <h3>平台课程资源</h3>
              <!-- <p>课程丰富，实战为主，提升学生动手能力</p> -->
              <p>平台提供丰富的大数据课程，<br />满足学校大数据专业课程开设需求</p>
              <ul class="form_box">
                <li>
                  <div>
                    <i></i>
                    <p>13 门大数据专业课</p>
                  </div>
                </li>
                <li>
                  <div>
                    <i></i>
                    <p>2 门大数据实战案例</p>
                  </div>
                </li>
                <li>
                  <div>
                    <i></i>
                    <p>2 门大数据认证课</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="course_img">
              <div class="pink"></div>
              <img src="@/zh-website/src/assets/BigData2.png" alt />
            </div>
          </div>

          <div class="surroundings">
            <h3>实训室环境资源</h3>
            <p>平台融合课件、实验手册、实验环境、多媒体视频等资源于一体</p>
            <ul class="application">
              <li v-for="(item, index) in picList" :key="index">
                <div class="application_title">{{ item.title }}</div>
                <div class="application_img" @mouseenter="enter" data-id="0">
                  <!-- <pic-zoom
                    :url="item.img"
                    :bigWidth="150"
                    :scale="3"
                    overlayStyle=" width:100%;height: 100%;border-radius: 3px;"
                  ></pic-zoom> -->
                  <img :src="item.img" alt="" />
                </div>
                <div class="application_text">
                  <h4>{{ item.text1 }}</h4>
                  <h4>{{ item.text3 }}</h4>
                  <p>{{ item.text2 }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 平台支撑 -->
        <div class="conent_box support">
          <h3>平台支撑</h3>
          <i class="selected"></i>
          <div class="_text">打造混合云模式的最佳用户实验体验</div>
          <ul class="support_box">
            <li>
              <img src="@/zh-website/src/assets/cloud1.png" alt />
              <div>
                <h3>华为公有云平台</h3>
                <p>
                  免部署、免维护、省成本
                  <br />无需本地物理实训环境 <br />支持随时随地访问
                </p>
              </div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/cloud3.png" alt />
              <div>
                <h3>学校私有云平台</h3>
                <p>
                  保留公有云融合接口，方便扩展
                  <br />提高学校硬件利用率 <br />支持随时随地访问
                </p>
              </div>
            </li>
          </ul>
          <h3 class="support_imgtit">可视可追溯的在线实验解决方案，提升实训教学效果</h3>
          <div class="support_imgbox"></div>
          <div class="support_imgtext" v-for="(item, index) in bottomText" :key="index">
            <h5>{{ item.title1 }}</h5>
            <p>{{ item.body }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {
    
  }
})
export default class Experiment extends Vue {
  bottomText= [
        {
          title1: "仿真实验环境",
          body: "真实还原大数据生产环境，用户可随时上机实验操作；",
        },
        {
          title1: "互动学习模式",
          body: "记录复习笔记，保存实验心得，参与提问回答，完成考试测评，参加平台竞赛",
        },
        {
          title1: "丰富实战案例",
          body: "平台提供项目案例类课程资源供学生进行学习，将学生培养为企业级实战人才。",
        },
        {
          title1: "有效资源扩展",
          body:
            "基于底层集群搭建平台，可进行横向扩展，实现硬件资源整合，以达到更高吞吐量、支撑更多用户。",
        },
        {
          title1: "权威认证学习",
          body: "提供华为认证专业课程相关资源，由华为全球培训中心专业讲师录制教学视频。",
        },
        {
          title1: "环境一键部署",
          body: "各组件自动化部署，减轻前期环境部署成本，聚焦实训本身。",
        },
      ]
      picList= [
        {
          title: "一站式服务",
          text1: "教学+生产+科研",
          text3: "满足多重能力提升",
          text2:
            "提供教学课程、自主实验、实验手册、在线视频等教学资源，提供数据存储、数据仓库等产品级服务同时也能够基于数据业务流进行科研数据分析与挖掘。",
          img: require("@/zh-website/src/assets/BigData3.jpg"),
        },
        {
          title: "丰富数据集",
          text1: "云端一键部署",
          text3: "用户随地接入，平台统一管理",
          text2:
            "满足不同行业大数据分析挖掘需求提供8个行业(金融、农业、电商、教育、能源、医疗、公共安全、交通)的行业数据，满足教师和学生的科研、学习需求。",
          img: require("@/zh-website/src/assets/BigData4.jpg"),
        },
        {
          title: "大数据生态",
          text1: "支持主流大数据生态",
          text3: "助力师生领略大数据地图全貌",
          text2:
            "平台提供了丰富的实验环境，为满足教学的实验需求，包括认知模块、平台搭建、数据采集、分析挖掘、可视化， 覆盖大数据主流生态组件。",
          img: require("@/zh-website/src/assets/BigData5.png"),
        },
      ]
      // 背景图样式文案
      list= {
        style: {
          "background-image": `url(${require("@/zh-website/src/assets/banner_certification.png")})`,
          height: "493px",
        },
        font1: "人工智能专业建设",
        font2: "",
        font3: "",
        font4: "全场景、端到端",
        font5: "培养智能时代智慧人才",
        button: "",
      }
}

</script>
<style lang="less" scoped>
p {
  padding-top: 10px;
}
// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
  max-width: 1366px;
  margin: 0 auto;
}
.center {
  padding-bottom: 30px;
}
.conent_box {
  background-color: #f8f8f8;
  padding: 2.8125rem 0 0;
  margin-bottom: 1.25rem;
  h3 {
    font-size: 1.75rem;
    text-align: center;
    color: #333;
  }
  .selected {
    display: block;
    width: 1.5625rem;
    height: 0.1875rem;
    background-color: #333333;
    margin: 0.625rem auto 0;
  }
  ._text {
    width: 100%;
    text-align: center;
    color: #999999;
    margin: 20px auto 1.875rem;
  }
  // 平台优势
  .personnel {
    display: flex;
    padding: 0 10.9375rem 4.0625rem;
    justify-content: space-between;
    li {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 16.5625rem;
      width: 20.1875rem;
      align-items: center;
      padding: 0 10px 0;
      color: #333;
      border: 1px solid #ccc;
      .personnel1 {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding-bottom: 1.5rem;
        img {
          width: 4.1875rem;
        }
      }
      .personnel2 {
        flex: 1;
        display: flex;
        flex-direction: column;
        h3 {
          font-size: 1.25rem;
          font-weight: 700;
          // padding-top: 0.875rem;
        }
        p {
          font-size: 0.875rem;
          text-align: center;
          color: #acacac;
          line-height: 160%;
          padding-top: 10px;
        }
      }
    }
  }
}
// 平台资源
.resources {
  padding: 2.8125rem 5.625rem 0;
  // 课程
  .course {
    margin-top: 5rem;
    display: flex;
    .course_box {
      display: flex;
      flex-direction: column;
      margin-top: 5rem;
      flex: 1;
      font-size: 1.5rem;
      h3 {
        text-align: left;
        font-size: 1.5rem;
        font-weight: 700;
      }
      p {
        font-size: 1.125rem;
        color: #999;
        padding-top: 10px;
      }
      .form_box {
        li {
          padding-top: 1.25rem;
          font-size: 1.125rem;
          div {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            i {
              display: inline-block;
              width: 0.1875rem;
              height: 0.1875rem;
              background-color: #dd0011;
              border-radius: 50%;
              margin-top: 22px;
            }
            p {
              width: 98%;
              color: #333;
            }
          }
        }
      }
    }
    .course_img {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      position: relative;
      overflow: hidden;
      margin-left: 20px;
      .pink {
        width: 30rem;
        height: 24.0625rem;
        background-color: pink;
      }
      img {
        position: absolute;
        top: 2.5rem;
        right: 2.5rem;
        width: 30rem;
        height: 24.0625rem;
      }
    }
  }
  // 环境
  .surroundings {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 1.5rem;
    margin-top: 90px;
    h3 {
      text-align: left;
      font-size: 1.5rem;
      font-weight: 700;
    }
    p {
      font-size: 1.125rem;
      font-weight: 700;
      color: #dd0011;
    }
    .application {
      font-size: 1rem;
      color: #fff;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 360px;
        display: flex;
        flex-direction: column;
        margin: 1.875rem 0;
        .application_title {
          width: 100%;
          height: 94px;
          background-image: url("../../../../assets/application.png");
          font-size: 20px;
          text-align: center;
          line-height: 94px;
          border-radius: 5px;
        }
        .application_img {
          width: 360px;
          height: 252px;
          img {
            width: 100%;
          }
          margin: 15px auto 27px;
        }
        .application_text {
          // letter-spacing: 2px;
          padding: 0 5px;
          h4 {
            font-size: 20px;
            color: #333;
            text-align: center;
            &:nth-child(1) {
              margin-bottom: 4px;
            }
          }
          p {
            text-align: justify;
            text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
            font-size: 14px;
            color: #666;
            font-weight: 400;
          }
        }
      }
    }
  }
  // 开发工具
  .open {
    display: flex;
    justify-content: space-between;
    li {
      width: 22.6875rem;
      height: 15.8125rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      border-radius: 0.3125rem;
      box-shadow: 0 0 3px 1px #ccc;
      padding: 1.75rem 0;
      div {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          // height: 100%;
          margin: 0 auto;
        }
      }
      p {
        font-size: 1.125rem;
        text-align: center;
        color: #333333;
        font-weight: 700;
        // padding-top: 1.25rem;
      }
    }
  }
  // 开发工具介绍
  .introduction {
    display: flex;
    justify-content: space-between;
    li {
      width: 22.6875rem;
      height: 12.5rem;
      display: flex;
      flex-direction: column;
      padding-top: 1.875rem;
      h4 {
        font-size: 1.5rem;
        margin: 0;
      }
      p {
        font-size: 0.875rem;
        color: #333333;
        padding-top: 1.125rem;
      }
    }
  }
  // 主流网站
  .website {
    font-size: 1.125rem;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    .website_head {
      // color: #dd0011;
      font-size: 1.125rem;
      font-weight: 700;
      color: #dd0011;
    }
    .website_box {
      display: flex;
      flex-wrap: wrap;
      padding: 1.5625rem 0 1.25rem;
      .web {
        .website_box_git {
          width: 13rem;
          height: 7.3125rem;
          background-color: #fff;
          margin-right: 1.25rem;
          border-radius: 0.3125rem;
          img {
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        p {
          text-align: center;
          padding: 1.25rem 0 1.875rem;
        }
      }
    }
  }
}
// 平台支撑
.support {
  padding-bottom: 30px;
  .support_imgbox {
    height: 325px;
    background: url("../../../../assets/BigData6.png") no-repeat center center;
    background-size: contain;
    width: 100%;
  }
  .support_imgtext {
    display: none;
    padding: 0 5px;
    // text-align: center;
    // h5 {
    //   color: #333;
    //   font-weight: 600;
    // }
    // p {
    //   padding-top: 5px;
    //   font-size: 14px;
    // }
  }
  .support_imgtit {
    font-size: 16px;
    // font-weight: 600;
    margin: 60px auto 20px;
    color: #999;
  }
  h4 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
  }
  .red {
    color: #dd0011;
    font-weight: 600;
  }
  .support_box {
    padding: 0 4.375rem;
    display: flex;
    justify-content: center;
    li {
      width: 25rem;
      height: 13.3125rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      margin: 0 3px;
      img {
        width: 4.3125rem;
        height: 2.75rem;
      }
      div {
        h3 {
          font-size: 1.5rem;
          color: #333;
        }
        p {
          font-size: 0.875rem;
          text-align: center;
          color: #555555;
        }
      }
    }
  }
  h4 {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 600;
  }
  .support_h4 {
    margin-top: 50px;
    color: #333;
  }
  .support_p {
    text-align: center;
  }
  .support_img {
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .advantage {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    h5 {
      font-size: 1.25rem;
      font-weight: 600;
      color: #333;
    }
    .advantage_left {
      width: 34.1875rem;
      margin-top: 2.125rem;
      padding-right: 9rem;
      display: flex;
      flex-direction: column;
      text-align: right;
    }
    .advantage_right {
      width: 36.375rem;
      margin-top: 2.125rem;
      padding-left: 11rem;
      display: flex;
      flex-direction: column;
    }
    .advantage_right_1 {
      padding-left: 14rem;
      margin-top: 35px;
    }
    .advantage_left_1 {
      padding-right: 12rem;
      margin-top: 35px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .WidCon {
    padding: 0 5%;
  }
  .resources .course .course_box .form_box li div p {
    padding-right: 10px;
  }
  .conent_box .personnel {
    padding: 0 100px 4.0625rem;
  }
  .resources .surroundings .application li {
    width: 32%;
  }
  .resources .surroundings .application li .application_img {
    width: 100%;
    margin-bottom: 10px;
  }
  .support .support_imgbox {
    height: 280px;
  }
}
@media screen and (max-width: 1200px) and (min-width: 901px) {
  .resources .course {
    margin: 0;
  }
  .conent .resources .course .course_img {
    display: none;
  }
  .resources .website .website_head {
    padding-top: 50px;
  }
}
@media screen and (max-width: 985px) and (min-width: 769px) {
  .resources .course {
    margin: 0;
  }
  .conent .resources .course .course_img {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  .conent_box {
    // 平台优势
    .personnel {
      padding: 0 0 30px;
      flex-direction: column;
      align-items: center;
      li {
        margin-bottom: 5px;
      }
    }
  }
  // 平台资源
  .resources {
    padding: 2.8125rem 0.3125rem 0;
    // 课程
    .course {
      margin-top: 0;
      flex-direction: column;
      .course_img {
        margin-top: 0.625rem;
      }
    }
    // 环境
    .surroundings {
      .application {
        flex-direction: column;
        height: 100%;
        li {
          .application_title {
            height: 70px;
            line-height: 70px;
            font-size: 18px;
          }
          .application_img {
            height: auto;
          }
          width: 100%;
          margin: 0.625rem auto;
        }
      }
    }
    // 开发工具
    .open {
      flex-direction: column;
      align-items: center;
      li {
        margin: 0.625rem auto;
        div {
          overflow: hidden;
        }
      }
    }
    // 开发工具介绍
    .introduction {
      flex-direction: column;
      li {
        width: 100%;
      }
    }
    // 主流网站
    .website {
      .website_box {
        justify-content: space-around;
      }
    }
  }
  // 平台支撑
  .support {
    .support_imgbox {
      display: none;
    }
    .support_box {
      padding: 0;
      flex-direction: column;
      align-items: center;
      li {
        margin-top: 5px;
        width: 100%;
      }
    }
    .support_imgtext {
      display: block;
      text-align: center;
      padding: 15px 5px;
      h5 {
        color: #333;
        font-weight: 600;
      }
      p {
        padding-top: 5px;
        font-size: 14px;
      }
    }
    .support_img {
      img {
        opacity: 0;
      }
    }
    .advantage {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .advantage_left {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_right {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_right_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_left_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
    }
  }

  .conent_box h3 {
    font-size: 18px;
  }

  .conent_box .personnel li .personnel2 h3 {
    font-size: 16px;
    font-weight: bold;
  }

  .resources .course .course_box {
    margin-top: 20px;
  }

  .resources .course .course_box p {
    font-size: 14px;
  }

  .resources .course .course_box .form_box li {
    padding-top: 0;
  }

  .resources .course .course_box h3 {
    font-size: 16px;
  }

  .resources .course .course_img .pink {
    display: none;
  }

  .resources .course .course_img img {
    display: none;
  }

  .resources .surroundings {
    margin-top: 20px;
  }

  .resources .surroundings h3 {
    font-size: 16px;
  }

  .resources .surroundings p {
    font-size: 14px;
  }

  .resources .surroundings .application li .application_text h4 {
    font-size: 16px;
  }

  .support .support_box li div h3 {
    font-size: 16px;
    font-weight: bold;
  }

  .conent_box {
    padding-top: 20px;
  }
  .resources .surroundings .application li .application_img {
    width: 100%;
  }
}
</style>
